// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyD2WwYRlL5znCqOjNm9i6QPZdODWJit0_E",
    authDomain: "pacenotes-fulltextsearch.firebaseapp.com",
    projectId: "pacenotes-fulltextsearch",
    storageBucket: "pacenotes-fulltextsearch.appspot.com",
    messagingSenderId: "169246699619",
    appId: "1:169246699619:web:80cf0c7000cda284cb8856",
    measurementId: "G-Z1CPJDKJ6B"
  },
  register_url_stripe:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/stripe",
  register_url_stripe_subscription:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/stripe-subscription",
  del_url_stripe_subscription:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/del-stripe-subscription",
  list_payment_methods:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/list-payment-method",
  add_payment_methods:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/create-payment-method",
  remove_payment_methods:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/detach-method-default",
  customer_stripe:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/get-customer/",
  set_default_payment_methods:"https://us-central1-pacenotes-fulltextsearch.cloudfunctions.net/api/set-payment-method-default",
};
